
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTimeLess as ObiTimeLessElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-time-less.js';
 
 
 

 
 export const ObiTimeLess = createComponent({
   react: React,
   tagName: 'obi-time-less',
   elementClass: ObiTimeLessElement,
   events: {
     
   }
  });
 
 